// @flow
import React, { type Node } from 'react';
import { CardCVCElement } from 'react-stripe-elements';

import StripeFormGroup, { createStyledStripeElement } from './StripeFormGroup';

const StyledCardCVCElement = createStyledStripeElement(CardCVCElement);

export type Props = {};

const StripeCreditCardCVCField = (props: Props): Node => (
  <StripeFormGroup {...props} label="CVC">
    {formGroupProps => <StyledCardCVCElement {...formGroupProps} />}
  </StripeFormGroup>
);

export default StripeCreditCardCVCField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardCVCField.jsx